import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import VueAnalytics from "vue-analytics"
import store from "./store";
import "./registerServiceWorker";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import {
  CHECK_AUTH,
  GET_CART,
  GET_CART_LOCAL,
  MERGE_CART,
  GET_PREFECTURE
} from "./store/actions.type";
import ApiService from "./common/api.service";
import DateFilter from "./common/date.filter";
import DateJAPFilter from "./common/dataJAP.filter";
import loadDateJAP from "./common/loadDateJAP.filter";
import DateJAPFormat from "./common/dateFormat.filter";
import ErrorFilter from "./common/error.filter";
import DateFJP from "./common/dateFormatJP.filter.js";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import JwtService from "@/common/jwt.service";
import VueMeta from "vue-meta";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

import {
  required,
  email,
  confirmed,
  min,
  max,
  numeric,
  digits
} from "vee-validate/dist/rules";
import { regex } from "vee-validate/dist/rules";
Vue.config.productionTip = false;
Vue.filter("date", DateFilter);
Vue.filter("dateJAP", DateJAPFilter);
Vue.filter("dateloadJAP", loadDateJAP);
Vue.filter("error", ErrorFilter);
Vue.filter("priceFormat", numFormat(numeral));
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.filter("dateF", DateJAPFormat);
Vue.filter("DateFJP", DateFJP);

extend("required", required);
extend("email", email);
extend("confirmed", confirmed);
extend("min", min);
extend("max", max);
extend("numeric", numeric);
extend("digits", digits);
extend("regex", regex);
const UrlNotChecked = ["order-thanks"];

ApiService.init();

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name && document) {
    document.body.classList.remove("fadeIn01");
  }
  next();
});

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  store.dispatch(GET_PREFECTURE);
  if (JwtService.getToken()) {
    if (to.name === "logout") return next();
    return Promise.all([store.dispatch(CHECK_AUTH)])
      .then(() => {
        if (!UrlNotChecked.includes(to.name)) {
          if (store.getters.isAuthenticated) {
            store.dispatch(GET_CART).then(() => {
              store.dispatch(MERGE_CART);
            });
          } else {
            store.dispatch(GET_CART_LOCAL);
          }
        }
      })
      .then(next)
      .catch(() => next({ name: "logout" }));
  } else {
    store.dispatch(GET_CART_LOCAL);
    next();
  }
});

let fadeInTimer = 0;

router.afterEach(() => {
  clearTimeout(fadeInTimer);
  document.body.classList.add("fadeIn01");
  fadeInTimer = setTimeout(() => {
    document.body.classList.remove("fadeIn01");
  }, 3000);
});
Vue.use(VueMeta);
Vue.use(VueToast, {
  position: "bottom-right"
});
// Vue.use(VueAnalytics, {
//   id: process.env.VUE_APP_GA_ID,
//   router
// });
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
